/**
 * "Talk to Hero" voice widget — email validation schema.
 *
 * GitHub issue #555. Mirrors the message/style already established by
 * `@/lib/validation/auth.ts`'s `signUpSchema`/`loginSchema` (reused, not
 * duplicated logic — this is its own schema because the widget's email
 * field has no password/confirm-password siblings), so an "invalid
 * email" message reads identically everywhere in the app.
 */
import { z } from 'zod';

export const widgetEmailSchema = z.object({
  email: z
    .string()
    .min(1, 'Please enter a valid email address')
    .email('Please enter a valid email address'),
});

export type WidgetEmailInput = z.infer<typeof widgetEmailSchema>;

/** Client-side pre-check used to disable the submit button / give instant
 * inline feedback. The server (`POST /api/v1/widget/validate-email`) is
 * still the authoritative validator — this never replaces that call. */
export function isLikelyValidEmail(email: string): boolean {
  return widgetEmailSchema.safeParse({ email }).success;
}
